import { Button } from 'cpool-components/input/Button';
import { REAL_ESTATE_TYPES } from 'cpool-constants';
import type { ApplicantCreation } from 'cpool-schemas';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LuPlus } from 'react-icons/lu';

import { RealEstateItem } from './RealEstateItem';
import { useApplicantAttribution } from '../../util/hooks/useApplicantAttribution';
import { getRealEstateDefaultValues } from '../../util/values/realEstate';

export const RealEstates: React.FC = () => {
    const { t } = useTranslation();
    const { control } = useFormContext<ApplicantCreation>();
    const attribution = useApplicantAttribution();

    const { append, fields, remove } = useFieldArray({
        control,
        keyName: 'realEstateId',
        name: 'immobilien',
    });

    const addRealEstate = () => {
        append(getRealEstateDefaultValues(attribution));
    };

    const realEstateTypeOptions = Object.values(REAL_ESTATE_TYPES).map((value) => ({
        label: t(`REAL_ESTATE.TYPE.${value}`),
        value,
    }));

    return (
        <div className="flex w-full flex-col gap-2">
            {fields.map((immobilie, index) => (
                <RealEstateItem
                    key={immobilie.realEstateId}
                    index={index}
                    control={control}
                    onRemove={() => remove(index)}
                    realEstateTypeOptions={realEstateTypeOptions}
                />
            ))}

            <div className="flex justify-center py-2">
                <Button type="button" variant="secondary" onClick={addRealEstate} iconLeft={<LuPlus className="h-4 w-4" />}>
                    {t('REAL_ESTATE.BUTTONS.ADD_REAL_ESTATE')}
                </Button>
            </div>
        </div>
    );
};
